import Vue from 'vue'
import i18n from '@/scripts/app-configs/i18n-config'

/**
 * Split duration object to readable string
 * @name durationObjectToString object to time string
 * @returns {string} Readable String based on split time object
 */

// TODO Add timeframe & configs support as needed
function durationObjectToString({ days = 0, hours = 0, minutes = 0 } = {}) {

  const daysLabel = days > 1 ? i18n.t('COMMON.DAYS') : i18n.t('COMMON.DAY')
  const hoursLabel = hours > 1 ? i18n.t('copy_401').toLowerCase() : i18n.t('CALENDAR.HOUR').toLowerCase()
  const minutesLabel = minutes > 1 ? i18n.t('copy_400').toLowerCase() : i18n.t('COMMON.MINUTES').toLowerCase()

  switch (true) {
    case days > 0:
      return `${days} ${daysLabel}`
    case hours > 0:
      return `${hours} ${hoursLabel}`
    case minutes > 0:
      return `${minutes} ${minutesLabel}`
    default:
      return ''
  }
}

Vue.filter('durationObjectToString', durationObjectToString)

export default durationObjectToString
